import Axios from "axios";
import {
    SET_ASSET_DEPRECIATION_METHOD_LIST,
    UNSET_ASSET_DEPRECIATION_METHOD_LIST,
} from "@/store/mutation-types";

import { getAssetDepreciationMethodList } from "@/store/api";

const state = {
    getAssetDepreciationMethodList: [],
};

const getters = {
    getAssetDepreciationMethodList(state) {
        return state.getAssetDepreciationMethodList;
    }
};

const mutations = {
    [SET_ASSET_DEPRECIATION_METHOD_LIST](state, data) {
        state.getAssetDepreciationMethodList = data;
    },
    [UNSET_ASSET_DEPRECIATION_METHOD_LIST](state) {
        state.getAssetDepreciationMethodList = [];
    }
};

const actions = {

    getAssetDepreciationMethodList({ commit }, data) {
        return new Promise((resolve, reject) => {
            Axios.get(getAssetDepreciationMethodList, data)
                .then(function (response) {
                    commit('SET_ASSET_DEPRECIATION_METHOD_LIST', response.data.data)
                    resolve(response);
                })
                .catch(function (error) {
                    commit('UNSET_ASSET_DEPRECIATION_METHOD_LIST')
                    reject(error);
                })
                .then((always) => {
                });
        });
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
